import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CardService } from '../../../services/card.service';
import { ToastrService } from 'ngx-toastr';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import {Location} from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';



@Component({
  selector: 'lounge-list',
  templateUrl: './lounge-list.component.html',
  styleUrls: ['./lounge-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoungeListComponent implements OnInit {
  public showLoader: boolean = false;
  isChecked: boolean = false; 
  showAll: boolean = false;
  selectedCity: any;
  selectedLounge: any;
  passUrl: string;
  kitId: string;
  isStudentPayCard: boolean = false;
  public searchCityName = "";
  public isCitySelected = false;
  public isLoungeSelected = false;
  public isTermsAccepted = false;
  addOnOrderData:any;
  public cityItems:any;

  @ViewChild('loungePassCardModal') loungePassCardModal: any;
  @ViewChild('loungeDocumentViewModal') loungeDocumentViewModal: any;  
 
  public menuItems = [
    {
      'icon': 'lounge1.png',
      'title': 'Vast Network of Partner Lounges',
      'url': '',
    },
    {
      'icon': 'lounge2.png',
      'title': 'Free Wi-Fi and Relaxing Amenities',
      'url': '',
    },
    {
      'icon': 'lounge3.png',
      'title': 'Complimentary Snacks, Drinks, Full Meals',
      'url': '',
    },
    {
      'icon': 'lounge4.png',
      'title': 'Premium Facilities for Added Comfort',
      'url': '',
    },
    {
      'icon': 'lounge5.png',
      'title': 'QR-Based Easy Lounge Entry Access',
      'url': '',
    },
  ]
  public specItems = [
    {
      'icon': 'spec1.png',
      'title': 'Voucher Usage Requires Identification',
      'url': '',
    },
    {
      'icon': 'spec2.png',
      'title': 'Non-Refundable and Non-Transferable',
      'url': '',
    },
    {
      'icon': 'spec3.png',
      'title': 'Stay Duration Limit Applies',
      'url': '',
    },
    {
      'icon': 'spec4.png',
      'title': 'Service Standards May Vary',
      'url': '',
    },
    {
      'icon': 'spec5.png',
      'title': 'Check Services on Website',
      'url': '',
    },
  ]

  public loungeList:any = [];
  public cityItemsLocal = [
    {
      'icon': 'Agartala.png',
      'title': 'Agartala',
      'url': ''
    },
    {
      'icon': 'Allahabad.png',
      'title': 'Allahabad',
      'url': ''
    },
    {
      'icon': 'Amritsar.png',
      'title': 'Amritsar',
      'url': ''
    },
    {
      'icon': 'Ayodhya.png',
      'title': 'Ayodhya',
      'url': ''
    },
    {
      'icon': 'Bengaluru.png',
      'title': 'Bengaluru',
      'url': ''
    },
    {
      'icon': 'Bhopal.png',
      'title': 'Bhopal',
      'url': ''
    },
    {
      'icon': 'Bhubaneswar.png',
      'title': 'Bhubaneswar',
      'url': ''
    },
    {
      'icon': 'Chandigarh.png',
      'title': 'Chandigarh',
      'url': ''
    },
    {
      'icon': 'Cochin.png',
      'title': 'Cochin',
      'url': ''
    },
    {
      'icon': 'Coimbatore.png',
      'title': 'Coimbatore',
      'url': ''
    },
    {
      'icon': 'Dehradun.png',
      'title': 'Dehradun',
      'url': ''
    },
    {
      'icon': 'Dibrugarh.png',
      'title': 'Dibrugarh',
      'url': ''
    },
    {
      'icon': 'Durgapur.png',
      'title': 'Durgapur',
      'url': ''
    },
    {
      'icon': 'Gwalior.png',
      'title': 'Gwalior',
      'url': ''
    },
    {
      'icon': 'Indore.png',
      'title': 'Indore',
      'url': ''
    },
    {
      'icon': 'Jammu.png',
      'title': 'Jammu',
      'url': ''
    },
    {
      'icon': 'Kannur.png',
      'title': 'Kannur',
      'url': ''
    },
    {
      'icon': 'Madurai.png',
      'title': 'Madurai',
      'url': ''
    },
    {
      'icon': 'Nagpur.png',
      'title': 'Nagpur',
      'url': ''
    },
    {
      'icon': 'Pune.png',
      'title': 'Pune',
      'url': ''
    },
    {
      'icon': 'Ranchi.png',
      'title': 'Ranchi',
      'url': ''
    },
    {
      'icon': 'Siliguri.png',
      'title': 'Siliguri',
      'url': ''
    },
    {
      'icon': 'Srinagar.png',
      'title': 'Srinagar',
      'url': ''
    },
    {
      'icon': 'Vadodara.png',
      'title': 'Vadodara',
      'url': ''
    },
    {
      'icon': 'Varanasi.png',
      'title': 'Varanasi',
      'url': ''
    },
    {
      'icon': 'Visakhapatnam.png',
      'title': 'Visakhapatnam',
      'url': ''
    }];

    public filteredCities:any =  [];
   
  public activeTab: string = '';
  public modalReference: any;

  constructor(public router: Router, private modalService: NgbModal, private cardService: CardService, public toast: ToastrService, private _location: Location, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.getCardDetails();
    this.getCityList();
    this.addOnOrderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ADD_ON_ORDER_TYPE));
    
    //this.filteredCities = this.cityItems;
  }

  getCardDetails() {
    this.cardService.getAllCardDetail().subscribe(resp => {
      let respData:any = resp.body;
      let card = respData.filter(data => data.cardVendor == 'WSFXSTUDENTSCC');
      if(card.length != 0) {
        this.kitId = card[0]["kitId"];
        this.isStudentPayCard = true;
      }
    });    
  }

  toggleView() {
    this.showAll = !this.showAll;
  } 
  
  proceedToNextPage(pageUrl: string): void {
    this.router.navigate([pageUrl]);
  }
  onCheckboxChange() {
    console.log('Checkbox state:', this.isChecked);
  }
  setActiveTab(tabIndex: string) {
    this.activeTab = tabIndex;
  }
  openLoungePassCardModal() {
    this.modalService.open(this.loungePassCardModal, { size: 'md', centered: true });
  }
 
  openESIMModal() {    
    if(this.isStudentPayCard && this.isStudentPayCard == true) {
      if(this.validate()) {
        // this.toast.success('Coming soon!');
        this.claimLounge();
        //this.modalService.open(this.loungePassCardModal, { centered: true });
      }
    } else {
      this.toast.error("Sorry! You do not have Student Pay Card");
    }
  }

  closeModalAndNavigate() {
      this.modalService.dismissAll(); 
  }

  getLounge(city) {
    this.showLoader = true;
    this.selectedCity = city;
    this.searchCityName = city.title;
    this.filterCities(this.searchCityName);
    this.isCitySelected = true;
    this.cardService.getLoungeAccessList(this.selectedCity.title).subscribe(res => {
      this.showLoader = false;
      console.log("Lounge Access List ============== ", res);
      this.loungeList = res.body;
    }, err => {
      this.showLoader = false;
      this.toast.error(err.error.message);
    });
  }

  selectLounge(lounge) {
    this.selectedLounge = lounge;
    this.isLoungeSelected = true;
    console.log(lounge);
  }

  validate() {
    if(!this.selectedCity) {
      this.toast.error("Please select City");
      return false;
    } else if(!this.selectedLounge) {
      this.toast.error("Please select Lounge");
      return false;
    } else if(!this.isChecked) {
      this.toast.error("Please accept terms and condition");
      return false;
    }
    return true;
  }

  
  claimLounge() {
    this.showLoader = true;
    let reqObj = {};
    this.cardService.getLoungeAccess(reqObj, this.kitId).subscribe(res => {
      this.showLoader = false;
      let respData = res.body;
      if(respData && respData["status"] ==  true) {
        let loungeData = respData["data"];
        this.passUrl = loungeData["ecert_url"];
        this.openLoungePassCardModal();
      } else if(respData && respData["status"] ==  false) {
        this.toast.error("Something went wrong!");          
      }
    }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
    });
  }

  
  goToNewFeatures() {
    this._location.back();
  }

  transform() { 
    return this.sanitized.bypassSecurityTrustResourceUrl(this.passUrl);
  }
 
  openLoungPass() {
    this.modalService.dismissAll(); 
    this.modalReference = this.modalService.open(this.loungeDocumentViewModal, { centered: true });
  }

  downloadLoungPass() {
    window.open(this.passUrl);
  }

  filterCities(searchCity) {
    if(searchCity != "") {
      this.filteredCities = this.cityItems.filter(obj => obj.title.includes(searchCity));
    } else {
      this.filteredCities = this.cityItems;
    }

  }

  clearCitySelection() {
    this.isCitySelected = false;
    this.isLoungeSelected = false;
    this.filteredCities = this.cityItems;
    this.selectedCity = {};
    this.searchCityName = "";
  }

  proceedToBuy() {
    if(this.isCitySelected) {
      if(this.isLoungeSelected) {
        if(this.isTermsAccepted) {
          if(this.addOnOrderData.orderType == 'BUY') {
            console.log(this.selectedCity, this.selectedLounge);
            sessionStorage.setItem(ConstantsKey.SELECTED_LOUNGE, JSON.stringify(this.selectedLounge));
            this.router.navigate(['/buy-lounge']);
          } else if(this.addOnOrderData.orderType == 'CLAIM') {
            // if(this.isStudentPayCard && this.isStudentPayCard == true) {
              this.claimLounge();
            /* } else {
              this.toast.error("Sorry! You do not have Student Pay Card");
            } */
          }

        } else {
          this.toast.error("Please accept the terms and conditions to proceed.");        
        }
      } else {
        this.toast.error("Please select Lounge");        
      }
    } else {
      this.toast.error("Please select city");
    } 

  }

  getCityList() {
    this.cardService.getLoungeAccessCities().subscribe(data => {

      let citiesList:any = data.body;
      // this.cityItems = this.cityItems.filter(obj => citiesList.includes(obj.title));
      let citiesObj = citiesList.map(obj => {
          let availCity: any = this.cityItemsLocal.filter(citiLocalObj => citiLocalObj.title == obj);
          return {
            title: obj,
            icon: availCity.length > 0 ? availCity[0].icon : 'Durgapur.png'
          }
        });

      this.cityItems = citiesObj;
      console.log(" ----------------------------------------- CITY ITEMS ",this.cityItems);
      this.filteredCities = this.cityItems;
    });
  }


  

}
